import { type ReactNode, type MouseEvent } from 'react';
import { colors } from '../../../themes';
import { Spinner } from '../../Feedback/Spinner';
import { StyledIconButton } from './style';

export type IconButtonProps = {
  children?: ReactNode;
  id?: string;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  isLoading?: boolean;
  isActive?: boolean;
  onClick?: ((e: MouseEvent<HTMLButtonElement>) => void) | (() => void);
  ref?: React.Ref<HTMLButtonElement>;
  testId?: string;
};

function IconButton({
  children,
  id,
  variant,
  isLoading,
  disabled,
  onClick,
  isActive,
  ref,
  testId,
  ...rest
}: IconButtonProps) {
  return (
    <StyledIconButton
      data-testid={testId ?? 'icon-button'}
      id={id}
      variant={variant}
      isLoading={isLoading}
      isActive={isActive}
      disabled={disabled || isLoading}
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) {
          onClick(e);
        }
      }}
      ref={ref}
      {...rest}
    >
      {isLoading ? <Spinner size="tiny" color={colors.primary.blue} /> : children}
    </StyledIconButton>
  );
}

export { IconButton };
